"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = exports.useTableField = void 0;
const Yup = __importStar(require("yup"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const form_number_field_1 = require("../../composite/form/fields/form-number-field");
const form_context_1 = require("../../composite/form/form-context");
const table_data_hook_1 = require("../../composite/table/hooks/table-data-hook");
const inline_table_context_1 = require("../inline-table-field/inline-table-context");
const array_move_1 = require("../../utils/array-move");
const async_state_hook_1 = require("../../utils/async-state-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const update_effect_1 = require("../../utils/update-effect");
const table_field_dialog_1 = require("./table-field-dialog");
const table_field_header_1 = require("./table-field-header");
const table_field_list_wrapper_1 = require("./table-field-list-wrapper");
const table_field_remove_dialog_1 = require("./table-field-remove-dialog");
const table_field_row_1 = require("./table-field-row");
const table_field_toolbar_1 = require("./table-field-toolbar");
function useTableField(options) {
    var _a;
    const intl = (0, react_intl_1.useIntl)();
    const inlineTableFieldContext = (0, react_1.useContext)(inline_table_context_1.InlineTableFieldContext);
    const formContext = (0, react_1.useContext)(form_context_1.FormContext);
    const defaultInitNewItem = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        const object = {
            id: (0, uuid_1.v4)(),
        };
        if (props.useOrderColumn) {
            const lastOrder = (_a = (0, lodash_1.max)(value.map((item) => (0, lodash_1.get)(item, props.orderColumnPath)))) !== null && _a !== void 0 ? _a : 0;
            (0, lodash_1.set)(object, props.orderColumnPath, lastOrder + 1);
        }
        return object;
    });
    const props = {
        showToolbar: true,
        disabled: false,
        disabledAdd: false,
        disabledEdit: false,
        disabledRemove: false,
        visibleAdd: true,
        visibleEdit: true,
        visibleRemove: true,
        visibleActionsColumn: true,
        useDnDOrdering: false,
        useOrderColumn: false,
        reactToColumnsChange: false,
        orderColumnPath: 'order',
        maxRows: 10,
        classes: {},
        createRowStyle: (0, react_1.useMemo)(() => () => ({}), []),
        highlightSelectedRow: false,
        onSelect: lodash_1.noop,
        onRowClick: lodash_1.noop,
        onSortChange: lodash_1.noop,
        initNewItem: defaultInitNewItem,
        validationSchema: (0, react_1.useMemo)(() => Yup.mixed(), []),
        showDetailBtnCond: lodash_1.stubTrue,
        showRadioCond: lodash_1.stubTrue,
        showCheckboxCond: lodash_1.stubFalse,
        showSpeedDialCond: lodash_1.stubFalse,
        defaultSort: (0, react_1.useMemo)(() => [], []),
        speedDialActions: (0, react_1.useMemo)(() => [], []),
        ToolbarComponent: table_field_toolbar_1.TableFieldToolbar,
        FooterComponent: null,
        HeaderComponent: table_field_header_1.TableFieldHeader,
        RowComponent: table_field_row_1.TableFieldRow,
        DialogComponent: table_field_dialog_1.TableFieldDialog,
        RemoveDialogComponent: table_field_remove_dialog_1.TableFieldRemoveDialog,
        ListWrapperComponent: table_field_list_wrapper_1.TableFieldListWrapper,
        ...options,
        columns: (0, react_1.useMemo)(() => {
            var _a;
            return (0, lodash_1.compact)([
                options.useOrderColumn
                    ? {
                        name: intl.formatMessage({
                            id: 'EAS_TABLE_FIELD_COLUMN_ORDER',
                            defaultMessage: 'Pořadí',
                        }),
                        datakey: (_a = options.orderColumnPath) !== null && _a !== void 0 ? _a : 'order',
                        width: 100,
                        visible: true,
                    }
                    : undefined,
                ...options.columns,
            ]);
        }, [intl, options.columns, options.orderColumnPath, options.useOrderColumn]),
        FormFieldsComponent: (0, react_1.useMemo)(() => function FormFieldsComponent(props) {
            var _a;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                options.useOrderColumn && (react_1.default.createElement(form_number_field_1.FormNumberField, { name: (_a = options.orderColumnPath) !== null && _a !== void 0 ? _a : 'order', disabled: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_FIELD_LABEL_ORDER", defaultMessage: "Po\u0159ad\u00ED" }), helpLabel: intl.formatMessage({
                        id: 'EAS_TABLE_FIELD_FIELD_HELP_ORDER',
                        defaultMessage: ' ',
                    }) })),
                options.FormFieldsComponent && (react_1.default.createElement(options.FormFieldsComponent, { ...props }))));
        }, [
            intl,
            options.FormFieldsComponent,
            options.orderColumnPath,
            options.useOrderColumn,
        ]),
    };
    const value = (_a = props.value) !== null && _a !== void 0 ? _a : [];
    const [sorts, setSorts] = (0, react_1.useState)((0, table_data_hook_1.convertToTableSorts)(props.defaultSort, props.columns));
    (0, update_effect_1.useUpdateEffect)(() => {
        props.onSortChange((0, table_data_hook_1.convertToApiSorts)(sorts));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(sorts)]);
    const [selectedIndexes, setSelectedIndexes] = (0, async_state_hook_1.useAsyncState)();
    /**
     * @deprecated
     */
    const selectedIndex = selectedIndexes === null || selectedIndexes === void 0 ? void 0 : selectedIndexes[0];
    /**
     * @deprecated
     */
    const setSelectedIndex = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        if (index === undefined) {
            setSelectedIndexes([]);
        }
        else {
            setSelectedIndexes([index]);
        }
    });
    const [columnsState, setColumnsState] = (0, react_1.useState)(deriveColumnsState(props.columns));
    (0, react_1.useEffect)(() => {
        if (props.reactToColumnsChange) {
            setColumnsState(deriveColumnsState(props.columns));
        }
    }, [props.columns, props.reactToColumnsChange]);
    const formDialogRef = (0, react_1.useRef)(null);
    const removeDialogRef = (0, react_1.useRef)(null);
    const showAddDialog = (0, event_callback_hook_1.useEventCallback)(async () => {
        var _a;
        await setSelectedIndex(undefined);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showEditDialog = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        var _a;
        await setSelectedIndex(index);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showRemoveDialog = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        var _a;
        await setSelectedIndex(index);
        (_a = removeDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const showDetailDialog = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        var _a;
        await setSelectedIndex(index);
        (_a = formDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const saveRow = (0, event_callback_hook_1.useEventCallback)((index, object) => {
        let newValue;
        if (index !== undefined) {
            newValue = [
                ...value.slice(undefined, index),
                object,
                ...value.slice(index + 1, undefined),
            ];
        }
        else {
            newValue = [...value, object];
        }
        props.onChange(newValue);
    });
    const removeRow = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        let newValue = value.filter((_, i) => i !== index);
        if (props.useOrderColumn) {
            // recalculate order for every item
            newValue = newValue.map((item, i) => {
                const newItem = { ...item };
                (0, lodash_1.set)(newItem, props.orderColumnPath, i + 1);
                return newItem;
            });
        }
        props.onChange(newValue);
        await setSelectedIndex(undefined);
    });
    /**
     * @deprecated
     */
    const selectRow = (0, event_callback_hook_1.useEventCallback)(async (index) => {
        if (index !== selectedIndex) {
            await setSelectedIndex(index);
            if (props.value != null) {
                props.onSelect(props.value[index], index);
            }
        }
        else {
            await setSelectedIndex(undefined);
            props.onSelect(null, index);
        }
    });
    const selectRows = (0, event_callback_hook_1.useEventCallback)(async (indexes, keepCurrent = true) => {
        if (keepCurrent) {
            for (const index of indexes) {
                if (!(selectedIndexes === null || selectedIndexes === void 0 ? void 0 : selectedIndexes.includes(index))) {
                    await setSelectedIndexes((selectedIndexes) => [
                        ...(selectedIndexes !== null && selectedIndexes !== void 0 ? selectedIndexes : []),
                        index,
                    ]);
                    if (props.value != null) {
                        props.onSelect(props.value[index], index);
                    }
                }
                else {
                    await setSelectedIndexes((selectedIndexes) => {
                        var _a;
                        return (_a = selectedIndexes === null || selectedIndexes === void 0 ? void 0 : selectedIndexes.filter((selectedIndex) => selectedIndex !== index)) !== null && _a !== void 0 ? _a : [];
                    });
                    props.onSelect(null, index);
                }
            }
        }
        else {
            await setSelectedIndexes(indexes);
            for (const index of indexes) {
                if (props.value != null) {
                    props.onSelect(props.value[index], index);
                }
            }
        }
    });
    const setColumnWidth = (0, event_callback_hook_1.useEventCallback)((datakey, width) => {
        setColumnsState((columnsState) => {
            var _a;
            const index = columnsState.findIndex((column) => column.datakey === datakey);
            if (index !== -1) {
                return [
                    ...columnsState.slice(0, index),
                    {
                        ...columnsState[index],
                        width: Math.max((_a = props.columns[index].minWidth) !== null && _a !== void 0 ? _a : 50, width),
                    },
                    ...columnsState.slice(index + 1, undefined),
                ];
            }
            else {
                return columnsState;
            }
        });
    });
    const actionButtonWidth = 20;
    const actionColumnWidth = (0, react_1.useMemo)(() => {
        let actionButtonsCount = 0;
        if (!props.disabled && props.useDnDOrdering) {
            actionButtonsCount++;
        }
        // this is ugly, but necessary for counting the action column items. Should be reworked somehow else.
        if ((inlineTableFieldContext === null || inlineTableFieldContext === void 0 ? void 0 : inlineTableFieldContext.withRemove) &&
            (formContext === null || formContext === void 0 ? void 0 : formContext.editing) &&
            !props.disabled) {
            actionButtonsCount++;
        }
        for (const row of value) {
            if (!props.disabled && props.showRadioCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        for (const row of value) {
            if (!props.disabled && props.showCheckboxCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        for (const row of value) {
            if (!props.disabled && props.showSpeedDialCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        for (const row of value) {
            if (props.disabled && props.showDetailBtnCond(row)) {
                actionButtonsCount++;
                break;
            }
        }
        return actionButtonsCount > 0
            ? actionButtonsCount * actionButtonWidth + 15
            : 0;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.useDnDOrdering,
        props.showRadioCond,
        props.showSpeedDialCond,
        props.showDetailBtnCond,
        inlineTableFieldContext === null || inlineTableFieldContext === void 0 ? void 0 : inlineTableFieldContext.withRemove,
        formContext === null || formContext === void 0 ? void 0 : formContext.editing,
        value,
    ]);
    /**
     * Swaps rows positions and optionaly also order attribute.
     */
    const swapRows = (0, event_callback_hook_1.useEventCallback)(({ oldIndex, newIndex }) => {
        let orders;
        if (props.useOrderColumn) {
            orders = value.map((item) => (0, lodash_1.get)(item, props.orderColumnPath));
        }
        const newValue = (0, array_move_1.arrayMove)(value, oldIndex, newIndex);
        if (props.useOrderColumn) {
            newValue.forEach((item, i) => (0, lodash_1.set)(item, props.orderColumnPath, orders[i]));
        }
        props.onChange(newValue);
    });
    const filteredColumns = columnsState
        .map((state) => {
        const column = props.columns.find((column) => column.datakey === state.datakey);
        return column !== undefined ? { ...column, ...state } : undefined;
    })
        .filter((column) => column !== undefined)
        .map((column) => column)
        .filter((column) => column.visible || column.visible === undefined);
    const toggleSortColumn = (0, event_callback_hook_1.useEventCallback)(async (datakey) => {
        var _a;
        await setSelectedIndex(undefined);
        const sortIndex = sorts.findIndex((sort) => sort.datakey === datakey);
        if (sortIndex === -1) {
            const column = filteredColumns.find((column) => column.datakey === datakey);
            setSorts([
                ...sorts,
                {
                    datakey,
                    field: (_a = column === null || column === void 0 ? void 0 : column.sortkey) !== null && _a !== void 0 ? _a : datakey,
                    order: 'ASC',
                    type: 'FIELD',
                },
            ]);
        }
        else {
            const sort = sorts[sortIndex];
            if (sort.order === 'ASC') {
                setSorts([
                    ...sorts.slice(0, sortIndex),
                    {
                        ...sort,
                        order: 'DESC',
                    },
                    ...sorts.slice(sortIndex + 1, undefined),
                ]);
            }
            else {
                setSorts([
                    ...sorts.slice(0, sortIndex),
                    ...sorts.slice(sortIndex + 1, undefined),
                ]);
            }
        }
    });
    const context = (0, react_1.useMemo)(() => ({
        disabled: props.disabled,
        columns: props.columns,
        value,
        disabledAdd: props.disabledAdd,
        disabledEdit: props.disabledEdit,
        disabledRemove: props.disabledRemove,
        visibleAdd: props.visibleAdd,
        visibleEdit: props.visibleEdit,
        visibleRemove: props.visibleRemove,
        visibleActionsColumn: props.visibleActionsColumn,
        onSelect: props.onSelect,
        onRowClick: props.onRowClick,
        columnsState,
        filteredColumns,
        sorts,
        speedDialActions: props.speedDialActions,
        showAddDialog,
        showEditDialog,
        showRemoveDialog,
        showDetailDialog,
        saveRow,
        removeRow,
        selectRow,
        selectRows,
        setColumnWidth,
        actionColumnWidth,
        showDetailBtnCond: props.showDetailBtnCond,
        showRadioCond: props.showRadioCond,
        showCheckboxCond: props.showCheckboxCond,
        showSpeedDialCond: props.showSpeedDialCond,
        initNewItem: props.initNewItem,
        validationSchema: props.validationSchema,
        useDnDOrdering: props.useDnDOrdering,
        createRowStyle: props.createRowStyle,
        highlightSelectedRow: props.highlightSelectedRow,
        classes: props.classes,
    }), [
        props.disabled,
        props.columns,
        props.disabledAdd,
        props.disabledEdit,
        props.disabledRemove,
        props.visibleAdd,
        props.visibleEdit,
        props.visibleRemove,
        props.visibleActionsColumn,
        props.onSelect,
        props.onRowClick,
        props.speedDialActions,
        props.showDetailBtnCond,
        props.showRadioCond,
        props.showCheckboxCond,
        props.showSpeedDialCond,
        props.initNewItem,
        props.validationSchema,
        props.useDnDOrdering,
        props.createRowStyle,
        props.highlightSelectedRow,
        props.classes,
        value,
        columnsState,
        filteredColumns,
        sorts,
        showAddDialog,
        showEditDialog,
        showRemoveDialog,
        showDetailDialog,
        saveRow,
        removeRow,
        selectRow,
        selectRows,
        setColumnWidth,
        actionColumnWidth,
    ]);
    return {
        props,
        context,
        selectedIndex,
        setSelectedIndex,
        selectedIndexes,
        setSelectedIndexes,
        formDialogRef,
        removeDialogRef,
        swapRows,
        toggleSortColumn,
    };
}
exports.useTableField = useTableField;
function Empty() {
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.Empty = Empty;
function deriveColumnsState(columns) {
    return columns.map((column) => ({
        datakey: column.datakey,
        width: column.width,
    }));
}
//# sourceMappingURL=table-field-hook.js.map